<script>
import appConfig from "@/app.config";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {},
  data() {
    return {
      masterPayroll: [],
      selectedPaymentMethod: {},
      deductions: [],
      paymentMethods: [],
      addAsset: [{}],
      currentAssets: [],
      employeeDeduction: {},
      salaryItems: [],
      data: {},
      totalSalary: 0,
      paymentMethod: {},
      totalDeductions: 0,
      salaries_total: [],
      total_dedu: {},
      submittedPayments: {},
    };
  },
  computed: {
    computedTotalSalary() {
      let totalItems = 0;
      let totalDeductionsInput = 0;

      this.masterPayroll.forEach(emp => {
        const penalty = parseFloat(emp.penalty || 0);
        const employeeDeduction = parseFloat(emp.employeeDeduction || 0);
          
        totalDeductionsInput += employeeDeduction + penalty;
        totalItems += parseFloat(emp?.total_balance || 0);
      });

      return totalItems - totalDeductionsInput;
    }
  },
  methods: {
    getPaymentMethods() {
      this.http.post("transactions/cash-accounts", {}).then((res) => {
        this.paymentMethods = res.data;
        console.log('toooooota', res)
      });
    },
    changePaymentMethod() {
      this.paymentMethods.forEach((method) => {
        if (method.cash_account_id == this.data.cash_account_id) {
          this.selectedPaymentMethod = method;
        }
      });
    },
    getSalaryItemBranches() {
      this.http
        .post("salary-items-branches/branch-items-query", {})
        .then((res) => {
          if (res.status) {
            this.salaryItems = res.data;
            console.log('sssss', this.salaryItems)
          }
        });
    },
    getMasterPayroll() {
      this.data.month = parseInt(this.data.date.split("-")[1]);
      this.data.year = this.data.date.split("-")[0];
      this.http.post("transactions/master-payroll", this.data).then((res) => {
        if (res.status) {
          this.masterPayroll = res.data;
          this.salaries_total = res.salaries
          this.total_dedu = res.totals
          console.log('asdfsdfsdfs', res.data);
          if (this.masterPayroll?.length > 0) {
            document.querySelectorAll(".money-btn").forEach((element) => {
              element.removeAttribute("disabled");
            });
          }
          if(res.msg) {
             this.popup.alert({
          title: this.$t("payroll.master.notification"),
          msg: this.$t("payroll.master.already_generated_msg")
        });
          }
        }
      });
    },
    changeDeduction(event, item) {
      console.log(item);
      if (event.target.value <= 0) {
        item.employeeDeduction = 0;
        return;
      }
      if (parseFloat(event.target.value) > parseFloat(item.total_loan)) {
        var data = {
          title: "popups.warning",
          template: `
          <h5>the deduction you insert it is more than the total  ?</h5>
        `,
        };
        this.popup.modal(data);
        item.employeeDeduction = 0;
        return;
      }
      // item.total_paid =
      //   parseFloat(item.total_paid) + parseFloat(event.target.value);
      item.employeeDeduction = parseFloat(event.target.value);
      // this.http
      //   .put("emps/loans", item.id, {
      //     paid_balance: parseFloat(event.target.value),
      //     month: this.data.month,
      //     year: this.data.year,
      //     emp_id: item.id,
      //   })
      //   .then((res) => {
      //     if (!res.status) {
      //       var data = {
      //         title: "popups.error",
      //         template: `
      //     <h5>try again later  ?</h5>
      //   `,
      //       };
      //       this.popup.modal(data);
      //       event.target.value = 0;
      //       return;
      //     }
      //     console.log("done");
      //   });
    },
    payMasterPayrollSalaries() {
       const key = `${this.data.year}-${String(this.data.month).padStart(2, '0')}`;
      const emps = this.masterPayroll.map((emp) => {
        return {
          id: emp.id,
          deduction: emp.employeeDeduction ? emp.employeeDeduction : 0,
          total_balance: emp.total_balance,
        };
      });
      console.log(emps);
      this.http
        .post("transactions/emps/pay", {
          month: this.data.month,
          year: this.data.year,
          emps,
          totalSalaries: this.totalSalary,
          totalDeductions: this.totalDeductions,
          cash_account_id: this.data.cash_account_id,
        })
        .then((res) => {
          if (res.status) {
            this.submittedPayments[key] = true;
            document.querySelectorAll(".money-btn").forEach((element) => {
              element.setAttribute("disabled", true);
            });
            console.log("done");
          }
        });
    },
    processPayModalData() {
      console.log('begin with this',this.masterPayroll);
      let totalItems = 0,
        totalDeductionsInput = 0;
      this.masterPayroll.forEach((emp) => {
        if (emp.employeeDeduction) {
          totalDeductionsInput += parseFloat(emp.employeeDeduction);
        }
        totalItems += parseFloat(emp?.total_balance);
      });

      console.log('llllldldldldldldl', { totalItems });
      this.totalDeductions = parseFloat(totalDeductionsInput);
      this.totalSalary =
        parseFloat(totalItems) - parseFloat(totalDeductionsInput);
      this.paymentMethod = this.selectedPaymentMethod;
    },
    getDeductions() {
      this.http.get("salary-deduction").then((res) => {
        this.deductions = res.data;
      });
    },
  },
  created() {
    this.getPaymentMethods();
    this.getSalaryItemBranches();
    // this.getDeductions();
  },
};
</script>

<template>
  <div class="row mb-4">
    <div class="col-md-10">
      <form @submit.prevent="getMasterPayroll()">
        <div class="row" style="align-items: flex-end">
          <div class="col">
            <label class="inline" for="toJobTitle">{{
              $t("payroll.master.date")
            }}</label>
            <input type="month" class="form-control" v-model="data.date" />
          </div>
          <div class="col">
            <label class="inline" for="toJobTitle">{{
              $t("payroll.master.payment_method")
            }}</label>
            <select
              v-model="data.cash_account_id"
              class="form-control fromto"
              id="toJobTitle"
              @change="changePaymentMethod()"
            >
              <option
                v-for="payment in paymentMethods"
                :key="payment"
                :value="payment.cash_account_id"
                :selcted="paymentMethods[-1]"
              >
                {{ $i18n.locale == "ar" ? payment?.name : payment?.name_en }}
              </option>
            </select>
          </div>
          <div class="col">
            <button type="submit" class="btn btn-primary">
              {{ $t("popups.search") }}
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-2 align-self-end">
      <button
        type="submit"
        class="btn btn-primary money-btn"
        data-bs-toggle="modal"
        @click="processPayModalData()"
        data-bs-target="#payPayrollModal"
        v-if="masterPayroll?.length > 0"
      >
        {{ $t("payroll.pay") }}
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table
              v-if="masterPayroll.length > 0"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              class="table table-centered table-nowrap align-middle"
              style="border: 2px solid gray"
            >
              <thead>
                <tr class="text-center" style="border: 2px solid gray">
                  <th style="border: 2px solid gray" scope="col" colspan="2">
                    {{ $t("payroll.master.descr") }}
                  </th>
                  <th
                    style="border: 2px solid gray"
                    scope="col"
                    :colspan="salaryItems.length"
                  >
                    {{ $t("payroll.master.earnings") }}
                  </th>
                  <th></th>
                  <th style="border: 2px solid gray" scope="col"></th>
                  <th style="border: 2px solid gray" scope="col" colspan="6">
                    {{ $t("payroll.master.deductions") }}
                  </th>
                  <th
                    style="border: 2px solid gray"
                    scope="col"
                    rowspan="2"
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr style="border: 2px solid gray">
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.no") }}
                  </th>
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.name_of_emp") }}
                  </th>
                  <th
                    style="border: 2px solid gray"
                    v-for="item in salaryItems"
                    :key="item"
                  >
                    {{ $i18n.locale == "ar" ? item?.name : item?.name_en }}
                  </th>
                  <th style="border: 2px solid gray">{{ $t('payroll.master.overtime') }}</th>
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.gross") }}
                  </th>
                  <th
                    style="border: 2px solid gray"
                    v-for="deduction in deductions"
                    :key="deduction"
                  >
                    {{
                      $i18n.locale == "ar"
                        ? deduction?.name
                        : deduction?.name_en
                    }}
                  </th>
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.tax") }}
                  </th>
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.penalties") }}
                  </th>
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.insurance") }}
                  </th>
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.total_loan") }}
                  </th>
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.normal_leave") }}
                  </th>
                  
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.absence_deduction") }}
                  </th>
                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.deductabe_loan") }}
                  </th>

                  <th style="border: 2px solid gray">
                    {{ $t("payroll.master.net") }}
                  </th>
                </tr>
                <tr
                  style="border: 2px solid gray"
                  v-for="(item, index) in masterPayroll"
                  :key="item"
                >
                  <td style="border: 2px solid gray">{{ index + 1 }}</td>
                  <td style="border: 2px solid gray">{{ item?.name }}</td>
                  <td
                    style="border: 2px solid gray"
                    v-for="(salary, i) in salaryItems"
                    :key="i"
                  >
                    {{
                      (
                        item.salary_items.find(
                          s => s.salary_item_id === salary.id
                        )?.value ?? 0
                      ).toLocaleString()
                    }}
                  </td>
                  <td>
                    {{ parseFloat(item.overtime_value) || 0 }}
                  </td>
                  <td style="border: 2px solid gray">
                    {{
                      item.salary_items
                        .reduce(
                          (accumulator, salaryItem) =>
                            accumulator +
                            parseFloat(
                              salaryItem?.value ? salaryItem?.value : 0
                            ),
                          0
                        )
                        ?.toLocaleString()
                    }}
                  </td>
                  <td style="border: 2px solid gray">{{ parseFloat(item?.tax) }}</td>
                  <td style="border: 2px solid gray">{{ parseFloat(item?.penalty) || 0 }}</td>
                  <td style="border: 2px solid gray">
                    {{
                      (
                        item.salary_items.reduce(
    (acc, salaryItem) =>
      acc +
      (
        (salaryItem.name_en.toLowerCase() === "cost of living" || salaryItem.name_en.toLowerCase() === "basic salary")
          ? parseFloat(salaryItem?.value || 0) : 0
      ),
    0
  ) * item?.insurance
).toLocaleString()
                    }}
                  </td>
                  <td style="border: 2px solid gray">
                    {{ parseFloat(item?.total_loan).toLocaleString() }}
                  </td>
                  <td style="border: 2px solid gray">
                    {{ parseFloat(item?.normal_leave_deduction).toLocaleString() || 0 }}
                  </td>
                  <td style="border: 2px solid gray">
                    {{ parseFloat(item?.absence_deduction).toLocaleString()|| 0 }}
                  </td>
                  <td style="border: 2px solid gray">
                    <input
                      class="money-btn"
                      @change="changeDeduction($event, item)"
                      type="number"
                      :value="
                        item.employeeDeduction ? item.employeeDeduction : 0
                      "
                    />
                  </td>
                  <td style="border: 2px solid gray">
                    {{
                      (
                        item.salary_items.reduce(
                          (accumulator, salaryItem) =>
                            accumulator +
                            parseFloat(
                              salaryItem?.value ? salaryItem?.value : 0
                            ),
                          0
                        ) -
                        item.salary_items.reduce(
    (acc, salaryItem) =>
      acc +
      (
        (salaryItem.name_en.toLowerCase() === "cost of living" || salaryItem.name_en.toLowerCase() === "basic salary")
          ? parseFloat(salaryItem?.value || 0) : 0
      ),
    0
  ) * item?.insurance -
      parseFloat(item?.tax) - parseFloat(item?.total_loan) - parseFloat(item?.absence_deduction) - 
      parseFloat(item?.normal_leave_deduction || 0) + parseFloat(item.overtime_value) - 
      parseFloat(item?.penalty || 0) - parseFloat(item?.employeeDeduction ? item?.employeeDeduction : 0) 
                      )?.toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">#</td>
  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">{{ $t('payroll.master.total') }}</td>

  <td
    v-for="(salary, i) in salaries_total"
    :key="i"
    style="border: 2px solid gray; font-size: larger; font-weight: bold;"
  >
    {{ salary.total_salary}}
  </td>

  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">{{ parseFloat(total_dedu.overtime_value).toLocaleString() }}</td>
  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">{{ salaries_total.reduce((sum, item) => sum + parseFloat(item.total_salary || 0), 0).toLocaleString() }}</td>
  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">{{ parseFloat(total_dedu.tax).toLocaleString() }}</td>
  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">{{ parseFloat(total_dedu.penalty).toLocaleString() }}</td>
  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">
  {{
    masterPayroll.reduce((totalInsurance, emp) => {
      const base = emp.salary_items?.reduce((sum, item) => {
        return ["basic salary", "cost of living"].includes(item.name_en?.toLowerCase())
          ? sum + parseFloat(item.value || 0)
          : sum;
      }, 0);
      return totalInsurance + base * parseFloat(emp.insurance || 0);
    }, 0).toLocaleString()
  }}
</td>



  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">{{ parseFloat(total_dedu.total_loan).toLocaleString() }}</td>
  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">{{ parseFloat(total_dedu.normal_leave_deduction).toLocaleString() }}</td>
  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">{{ parseFloat(total_dedu.absence_deduction).toLocaleString() }}</td>
  <td style="border: 2px solid gray; font-weight: bold;">{{$t('payroll.master.totalnewpay')}}</td>

  <td style="border: 2px solid gray; font-size: larger; font-weight: bold;">
    {{ computedTotalSalary.toLocaleString() }}
  </td>
</tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Start Add Modal-->
  <div
    class="modal fade"
    id="payPayrollModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <form @submit.prevent="payMasterPayrollSalaries()">
          <div class="modal-header">
            <div class="d-flex justify-content-around">
              <!-- <h5 class="modal-title" id="exampleModalLabel">
                {{ $t("emps.pay") }}
              </h5> -->
              <h5 class="modal-title" id="exampleModalLabel">
                {{ $t("payroll.master.master_title") }}
              </h5>
            </div>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              style="margin: 0"
            ></button>
          </div>

          <div class="modal-body">
            <div class="pay-card">
              <div class="mb-4">
                <label for="asset_id">{{
                  $t("emps.payment_details.title")
                }}</label>
                <hr />
              </div>
              <div class="row">
                <div class="col">
                  <label class="d-block">
                    {{ $t("emps.payment_details.from") }}
                  </label>
                  <hr />
                  <label class="d-block">
                    {{ $t("emps.payment_details.amount") }}
                  </label>
                  <hr />

                  <label class="d-block">
                    {{ $t("emps.payment_details.month") }}
                  </label>
                  <hr />

                  <label class="d-block">
                    {{ $t("emps.payment_details.year") }}
                  </label>
                  <hr />
                </div>
                <div class="col">
                  <label class="d-block">
                    {{
                      $i18n.locale == "ar"
                        ? paymentMethod?.name
                        : paymentMethod?.name_en
                    }}
                  </label>
                  <hr />

                  <label class="d-block">
                    {{ parseFloat(totalSalary).toLocaleString() }}
                  </label>
                  <hr />

                  <label class="d-block">
                    {{ data.month }}
                  </label>
                  <hr />

                  <label class="d-block">
                    {{ data.year }}
                  </label>
                  <hr />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'">
            <button
              data-bs-dismiss="modal"
              type="submit"
              class="btn btn-primary"
            >
              {{ $t("emps.pay") }}
            </button>
            <button
              data-bs-dismiss="modal"
              type="button"
              class="btn btn-danger"
            >
              {{ $t("popups.cancel") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!--End Add Modal-->
</template>

<style scoped>
th td tr {
  border: 2px solid !important;
}
.pay-card {
  background: #fafafa;
  margin: 1rem;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>
